import { NgModule } from '@angular/core';
import { FcaddetailComponent } from './fcaddetail.component';
import { FcadformComponent } from './fcadform.component';
import { FcbasicModule } from '../fcbasic/index.module';
import { FclayoutModule } from '../fclayout/index.module';
import { FctlbModule } from '../fctlb/index.module';
import { FcmodalModule } from '../fcmodal/index.module';
import { FcadcarouselComponent } from './fcadcarousel.component';
import { FcadprintComponent } from './fcadprint.component';
import { FcshareModule } from '../fcshare.modal';
@NgModule({
  imports: [
    FcshareModule,
    FcbasicModule,
    FclayoutModule,
    FctlbModule,
    FcmodalModule,
  ],
  exports: [
    FcaddetailComponent,
    FcadformComponent,
    FcadcarouselComponent,
    FcadprintComponent
  ],
  declarations: [
    FcaddetailComponent,
    FcadformComponent,
    FcadcarouselComponent,
    FcadprintComponent
  ],
  providers: [
  ]
})
export class FcadModule { }
